import React, { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

type SearchExploreHeaderProps = {
  title?: string;
  onBack: () => void;
};

const SIDE_SLOT_PX = 40;

const SearchExploreHeader: React.FC<SearchExploreHeaderProps> = ({
  title = "SEARCH PLANT EXPLORE",
  onBack,
}) => (
  <Box
    sx={{
      position: "sticky",
      top: 0,
      zIndex: 20,
      bgcolor: "#fff",
      px: 2,
      pt: "calc(10px + env(safe-area-inset-top, 0px))",
      pb: "10px",
      borderBottom: "1px solid #e0e0e0",
      WebkitBackfaceVisibility: "hidden",
      backfaceVisibility: "hidden",
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        minHeight: SIDE_SLOT_PX,
      }}
    >
      <Box
        sx={{
          width: SIDE_SLOT_PX,
          height: SIDE_SLOT_PX,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <IconButton
          onClick={onBack}
          aria-label="Back to explorer"
          sx={{
            width: SIDE_SLOT_PX,
            height: SIDE_SLOT_PX,
            flexShrink: 0,
            p: 0,
            m: 0,
            color: "#111",
            borderRadius: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": { bgcolor: "rgba(0,0,0,0.04)" },
          }}
        >
          <ArrowBackIcon
            sx={{ fontSize: 28, display: "block" }}
          />
        </IconButton>
      </Box>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          px: 0.5,
          height: SIDE_SLOT_PX,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          component="span"
          sx={{
            m: 0,
            p: 0,
            textAlign: "center",
            fontWeight: 800,
            fontSize: 16,
            letterSpacing: "0.06em",
            lineHeight: 1,
            color: "#222",
          }}
        >
          {title}
        </Typography>
      </Box>

      <Box
        aria-hidden
        sx={{
          width: SIDE_SLOT_PX,
          height: SIDE_SLOT_PX,
          flexShrink: 0,
        }}
      />
    </Box>
  </Box>
);

export default memo(SearchExploreHeader);
